/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_optimizer_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Apex Team evaluates all valid combinations of 5 drivers + 2 constructors within the $100M budget cap. Expected points are weighted using:`)
};

const es_about_optimizer_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El Equipo Apex evalúa todas las combinaciones válidas de 5 pilotos + 2 constructores dentro del presupuesto de $100M. Los puntos esperados se ponderan usando:`)
};

const de_about_optimizer_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Apex-Team bewertet alle gültigen Kombinationen von 5 Fahrern + 2 Konstrukteuren innerhalb des $100M-Budgetlimits. Erwartete Punkte werden gewichtet anhand:`)
};

const nl_about_optimizer_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De Apex Team evalueert alle geldige combinaties van 5 coureurs + 2 constructeurs binnen het $100M budgetlimiet. Verwachte punten worden gewogen op basis van:`)
};

const fr_about_optimizer_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’Équipe Apex évalue toutes les combinaisons valides de 5 pilotes + 2 constructeurs dans le plafond budgétaire de $100M. Les points attendus sont pondérés selon :`)
};

const it_about_optimizer_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il Team Apex valuta tutte le combinazioni valide di 5 piloti + 2 costruttori entro il tetto di budget di $100M. I punti attesi sono ponderati usando:`)
};

const pt_br2_about_optimizer_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Equipe Apex avalia todas as combinações válidas de 5 pilotos + 2 construtores dentro do teto de orçamento de $100M. Os pontos esperados são ponderados usando:`)
};

const pt_about_optimizer_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Equipa Apex avalia todas as combinações válidas de 5 pilotos + 2 construtores dentro do teto de orçamento de $100M. Os pontos esperados são ponderados usando:`)
};

const ja_about_optimizer_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apexチームは$100Mの予算上限内で5ドライバー + 2コンストラクターのすべての有効な組み合わせを評価します。期待ポイントは以下を使用して重み付け:`)
};

const zh_about_optimizer_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apex团队评估在$100M预算上限内所有5名车手 + 2支车队的有效组合。预期积分使用以下方式加权：`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_optimizer_p1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_optimizer_p1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_optimizer_p1", locale)
	if (locale === "en") return en_about_optimizer_p1(inputs)
	if (locale === "es") return es_about_optimizer_p1(inputs)
	if (locale === "de") return de_about_optimizer_p1(inputs)
	if (locale === "nl") return nl_about_optimizer_p1(inputs)
	if (locale === "fr") return fr_about_optimizer_p1(inputs)
	if (locale === "it") return it_about_optimizer_p1(inputs)
	if (locale === "pt-BR") return pt_br2_about_optimizer_p1(inputs)
	if (locale === "pt") return pt_about_optimizer_p1(inputs)
	if (locale === "ja") return ja_about_optimizer_p1(inputs)
	return zh_about_optimizer_p1(inputs)
};